module.exports = __webpack_public_path__ + "img/048.9b0933e5.jpg";